import React from 'react';
import { PageTitleIconProps } from '../types';
import { usePageTitleIconData } from './ajaxPageTitleIconInfo';
import { PageTitleIcon as StormPageTitleIcon } from '@amzn/storm-ui-page-header';

export const PageTitleIcon: React.VFC<PageTitleIconProps> = ({
  id,
  isActive,
  iconAPI,
  apiCallFailureMessage,
  apiCallSuccessMessage,
  iconStatusAPI,
}) => {
  const {
    toggled,
    showSuccessBanner,
    showFailBanner,
    requestFailMessage,
    requestSuccessMessage,
    pageTitleIconToggleEvent,
  } = usePageTitleIconData({
    iconAPI,
    id,
    isActive,
    apiCallFailureMessage,
    apiCallSuccessMessage,
    iconStatusAPI,
  });

  if (!iconAPI) return null;
  if (typeof isActive == 'undefined' && !iconStatusAPI) return null;

  return (
    <StormPageTitleIcon
      id={id}
      isActive={toggled}
      onClick={pageTitleIconToggleEvent}
      label="PageTitleIcon"
      {...(showSuccessBanner &&
        !!requestSuccessMessage && {
          alertVariant: 'success',
          alertMessage: requestSuccessMessage,
        })}
      {...(showFailBanner &&
        !!requestFailMessage && {
          alertVariant: 'error',
          alertMessage: requestFailMessage ?? '',
        })}
    />
  );
};
